import React from "react";
import "./GridEmptyState.css";

const ItemsEmptyIllustration = ({ accentColor }) => (
  <svg
    className="grid-empty-state__illustration"
    viewBox="0 0 160 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="28"
      y="18"
      width="88"
      height="72"
      rx="12"
      className="grid-empty-state__illustration-card"
    />
    <path
      d="M44 42h56M44 54h40M44 66h48"
      className="grid-empty-state__illustration-lines"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <circle
      cx="108"
      cy="78"
      r="22"
      className="grid-empty-state__illustration-search-ring"
      stroke={accentColor}
      strokeWidth="3"
    />
    <path
      d="M124 94l14 14"
      stroke={accentColor}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <circle
      cx="108"
      cy="78"
      r="8"
      fill={accentColor}
      opacity="0.35"
    />
    <path
      d="M52 30l8-10M80 30l-8-10"
      className="grid-empty-state__illustration-spark"
      stroke={accentColor}
      strokeWidth="2.5"
      strokeLinecap="round"
      opacity="0.7"
    />
  </svg>
);

/**
 * Empty state for modern data grids (filtered results, no rows).
 */
const GridEmptyState = ({
  isDarkMode = false,
  themeColor = "#0d9488",
  title = "No items found",
  description = "Try adjusting your search or filters to find what you're looking for.",
  onClearFilters,
  clearFiltersLabel = "Clear filters",
}) => {
  return (
    <div
      className={`grid-empty-state${isDarkMode ? " grid-empty-state--dark" : ""}`}
      style={{ "--grid-empty-accent": themeColor }}
    >
      <ItemsEmptyIllustration accentColor={themeColor} />
      <h3 className="grid-empty-state__title">{title}</h3>
      <p className="grid-empty-state__description">{description}</p>
      {onClearFilters && (
        <button
          type="button"
          className="grid-empty-state__action"
          onClick={onClearFilters}
        >
          <i className="fa fa-filter" aria-hidden="true" />
          {clearFiltersLabel}
        </button>
      )}
    </div>
  );
};

export default GridEmptyState;
